
import type { Dispatch } from 'redux';

import { createToolbarEvent, sendAnalytics } from '../../analytics';
import { translate } from '../../base/i18n';
import { IconLivePad } from '../../base/icons';
import { connect } from '../../base/redux';
import { AbstractButton, type AbstractButtonProps } from '../../base/toolbox/components';
import { isLocalVideoTrackDesktop } from '../../base/tracks';
import { toogleEtherPad } from '../../toolbox/actions.any';
import { setShareMenuVisible } from '../../toolbox/actions.web';
import { toggleDocumentedit } from '../actions';


type Props = AbstractButtonProps & {

    /**
     * Whether the shared document is being edited or not.
     */
    _editing: boolean,

    /**
     * OnEdit Function.
     */
     _onEdit: boolean,

    /**
     * Redux dispatch function.
     */
    dispatch: Dispatch<any>,

    _visibility: boolean,
    etherpadState: boolean,
    _isDisabled: boolean
};

/**
 * Implements an {@link AbstractButton} to open the chat screen on mobile.
 */
class SharedDocumentButton extends AbstractButton<Props, *> {
    accessibilityLabel = 'toolbar.accessibilityLabel.document';
    icon = IconLivePad;
    label = 'toolbar.documentOpen';
    toggledLabel = 'toolbar.documentClose';

    /**
     * Handles clicking / pressing the button, and opens / closes the appropriate dialog.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        sendAnalytics(createToolbarEvent(
            'toggle.etherpad',
            {
                enable: !this.props._editing
            }));


        this.props.dispatch(toogleEtherPad(!this.props.etherpadState));
        this.props.dispatch(toggleDocumentedit(!this.props._onEdit));
        if (navigator.product !== 'ReactNative') {
            this.props.dispatch(setShareMenuVisible(!this.props._visibility));
        }
    }

    /**
     * Indicates whether this button is disabled or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isDisabled() {
        return this.props._isDisabled;
    }

    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._editing;
    }
}

/**
 * Maps part of the redux state to the component's props.
 *
 * @param {Object} state - The redux store/state.
 * @param {Object} ownProps - The properties explicitly passed to the component
 * instance.
 * @returns {Object}
 */
function _mapStateToProps(state: Object, ownProps: Object) {
    const { documentUrl, editing, onEdit, partId } = state['features/etherpad'];
    const { visible = Boolean(documentUrl) } = ownProps;
    const _visibility = state['features/toolbox'].visibility;
    const etherpadState = state['features/etherpad']?.editing;
    const participants = state['features/base/participants'];
    const participant = participants.filter(i => i.local === true);
    const isGenericIFrameVisible = state['features/genericiframe'].visible;


    // const localVideo = getLocalVideoTrack(state['features/base/tracks']);
    const videoTrack = isLocalVideoTrackDesktop(state);

    let _isDisabled;

    if (partId) {
        _isDisabled = editing && partId !== participant[0].id;
    } else {
        _isDisabled = videoTrack || false;
    }

    return {
        _editing: editing,
        _onEdit: onEdit,
        visible,
        _visibility,
        etherpadState,
        _isDisabled: isGenericIFrameVisible ? true : _isDisabled
    };
}

export default translate(connect(_mapStateToProps)(SharedDocumentButton));
